<template>
    
    <h3 style="text-align: left;">Solicitudes de inspección</h3><br>
    <div class="col-md-12 row"> 
      <div class="col-md-4">
          <span>Inspector:</span>
          <select class="form-control">
              <option></option>
              <option :value="datos.email" v-for="datos  in datosinspectores">{{datos.email }}</option>
          </select>
      </div>
      <div class="col-md-4">
          <span>Buscar Columna:</span>
          <select class="form-control" v-model="searchField">
              <option value="folio">Folio</option>
              <option value="razon_social">Razon Social</option>
          </select>
  
          
      </div>
      <div class="col-md-4">
          <span>Buscar: </span>
          <input type="text" class="form-control" v-model="searchValue">
      </div>
    </div>
    <br> 
    <EasyDataTable
    :headers="headers"
    :items="solicitudes"
    :search-field="searchField"
    :search-value="searchValue"
    :loading="loading"
    >
    <template #item-folio="item">
        <a href="#" @click="irCotizacion(item)">{{item.folio}}</a>
    </template>
    <template #item-razon_social="item">
        <a href="#" @click="irSolicitudInspeccion(item)">{{item.razon_social}}</a>
    </template>
    <template #item-formulario="item">
      <div v-if="item.formulario.length > 0">
        <span v-if="item.formulario[0].estatus == 'Pendiente' " class="circle ">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[0].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[1].estatus == 'Pendiente' " class="circle">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[1].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[2].estatus == 'Pendiente' " class="circle">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[2].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[3].estatus == 'Pendiente' " class="circle">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[3].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[4].estatus == 'Pendiente' " class="circle">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[4].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[5].estatus == 'Pendiente' " class="circle">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[5].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[6].estatus == 'Pendiente' " class="circle">&nbsp;&nbsp;&nbsp;</span>
        <span v-if="item.formulario[6].estatus == 'Completado' " class="circlecolor">&nbsp;&nbsp;&nbsp;</span>
        <span
  v-if="!item.formulario || !item.formulario[7]"
  class="circulorojo">
  &nbsp;&nbsp;&nbsp;
</span>

<span
  v-else-if="item.formulario[7].estatus == 'Pendiente'"
  class="circle">
  &nbsp;&nbsp;&nbsp;
</span>

<span
  v-else-if="item.formulario[7].estatus == 'Completado'"
  class="circlecolor">
  &nbsp;&nbsp;&nbsp;
</span>
       
       
      </div>
      </template>
      <template #item-url_formato_solicitud_cotizacion="item">
        <div class="operation-wrapper" >
          <!-- Input de archivo oculto -->
          <input type="file" id="fileInput" ref="fileInput" class="form-control" style="display:none;" @change="handleFileChange"/>
      
          <!-- Botón para seleccionar el archivo -->
          <button @click="triggerFileInput(item)" class="btn  btn-sm" title="Subir Formato de Solicitud de Inspección con Firma" style="background-color: #F49315; color: white;">
            <span class="fa fa-upload"></span>
          </button>
      
          <!-- Mostrar el nombre del archivo seleccionado 
          <span v-if="selectedFileName">{{ selectedFileName }}</span>-->
      
          <!-- Enlace que muestra la URL del archivo -->
           &nbsp;
          <a v-if="item.url_formato_solicitud_cotizacion" :href="this.$rutaImagenes+item.url_formato_solicitud_cotizacion" target="_blank" 
          rel="noopener noreferrer"
          class="btn btn-info btn-sm" title="Formato de Solicitud de Inspección con Firma Tamaño máximo 5 MB" style="background-color: #F49315; color: white;"><span class="fa fa-file-pdf"></span></a>
        </div>
      </template>
<template #item-operation="item">
    <div class="operation-wrapper">
      <!--<img
        src="./images/delete.png"
        class="operation-icon"
        @click="deleteItem(item)"
      />-->
      <!--<img
        src="./images/edit.png"
        class="operation-icon"
        @click="editItem(item)"
      />-->
      
      <button class="btn btn-light btn-sm" type="button" @click="irSolicitudInspeccion(item)"><span class="fa fa-eye" style="color:#F49315;"></span></button> &nbsp;
      <button class=" btn btn-light btn-sm" type="button" @click="generatePdf(item)"><span class="fa fa-file-pdf"></span></button> &nbsp;
      <button class="btn btn-light btn-sm" v-if="rol == 'Administrador' || 'Inspector' " type="button" @click="eliminarSolicitud(item)"><span class="fa  fa-trash" style="color:red;"></span></button>
   
    </div>
  </template>
  </EasyDataTable>
  <br>
</template>
<script>
import axios from 'axios';
import "vue3-easy-data-table/dist/style.css";
import Swal from 'sweetalert2';
import { mapState, mapMutations } from 'vuex';
export default {
    data() {
        return {
            loading:false,
            searchField:[],
            searchValue:[],
            datosinspectores:[],
            rol: localStorage.getItem('userRoles'),
            headers:[],
            solicitudes:[],
            selectedFile: null,        // Almacena el archivo seleccionado
            selectedFileName: '',      // Almacena el nombre del archivo seleccionado
            idcotizacion:''
        }
    },
    created() {
        this.consultarInspector();
        this.consultarSolicitudes();
    },
    methods: {
      triggerFileInput(item) {
        this.idcotizacion = item.idcotizacion;
      this.$refs.fileInput.click(); // Desencadena el clic en el input de archivo oculto
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.selectedFileName = file.name;
        this.uploadFile(); // Subir el archivo automáticamente después de seleccionarlo
      }
    },
    uploadFile() {
      if (this.selectedFile) {
        const formData = new FormData();
        formData.append('file', this.selectedFile);
        formData.append('cotizacion_id',  this.idcotizacion );

        // Realizar la solicitud de subida de archivo
        axios.post(this.$rutaServer+'uploadFormatoSolicitud', formData)
          .then(response => {
            console.log('Archivo subido con éxito:', response.data);
            Swal.fire('¡Éxito!', 'Archivo guardado', 'success');
            this.consultarSolicitudes();
            // Aquí podrías actualizar item.url_formato_solicitud_cotizacion con la URL del archivo subido
          })
          .catch(error => {
            //console.error('Error al subir el archivo:', error.response.data.errors);
            if (error.response.data.errors) {
                // Asegúrate de que haya un error en el índice 0 del campo 'pdf'
                if (error.response.data.errors.file[0]) {
                    Swal.fire('¡Error!', 'El Formato Solicitud con Firma no debería pesar más de 5 MB.', 'error');
                }
            } else {
                // Si no existe la estructura de error esperada
                alert(JSON.stringify(error.response.data));
            }
          });
      }
    },
      generatePdf(item){
        console.log(JSON.stringify(item) +'aqer');
          axios.post(this.$rutaServer+'generatePdfSolicitudInspeccion', {
            id:item.idcotizacion
        // Aquí van los datos que envías en el body
    }, {
        responseType: 'blob'// Importante para datos binarios
    }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'solicitudinspeccion.pdf'); // Nombre del archivodocument.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }).catch(error => {
        console.error("Hubo un error al generar el PDF:", error);
    });
        },
        irCotizacion(item){
            
            localStorage.removeItem('idcotizacion');
            localStorage.setItem('idcotizacion',item.idcotizacion);
            this.$router.push('/mostrarcotizacion');
        },
        irSolicitudInspeccion(item){
            localStorage.removeItem('idcotizacion');
            localStorage.setItem('idcotizacion',item.idcotizacion);
            this.$router.push('/solicitudinspeccion');
        },
        consultarInspector(){
        const token = localStorage.getItem('accessToken');
            const config = {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
                }
            };
       
        axios.get(this.$rutaServer +'inspectores',config)

          .then(response => {
            //console.log(response.data);
            this.datosinspectores = response.data.data;
            
          })
          .catch(error => {
            console.error('Error submitting form:', error);
           
          });
      },
      consultarSolicitudes(){
        this.loading = true;
        const token = localStorage.getItem('accessToken');
            const config = {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
                }
            };
       
        //axios.get(this.$rutaServer +'api/inspectores',config)
        axios.post(this.$rutaServer +'consultarSolicitudes')

          .then(response => {
            //console.log(response.data);
            this.loading = false;
            this.solicitudes = response.data.data;
            console.log(response.data.data);
            this.headers = [
                { text: "Información Llenada", value: "formulario", sortable: true},
                { text: "Cotización", value: "folio", sortable: true},
                { text: "Solicitud de inspección", value: "razon_social", sortable: true },
                { text: "Inspección", value: "estatus_solicitud", sortable: true },
                { text: "Inspector", value: "inspector", sortable: true },
                { text: "Inspector", value: "inspector", sortable: true },
                { text: "Formato Solicitud Firma", value: "url_formato_solicitud_cotizacion", sortable: true },
                { text: "Operation", value: "operation", sortable: true },
                        
                

                    ];
                    this.searchField  = ['folio','razon_social','estatus_solicitud','inspector'];
            
          })
          .catch(error => {
            console.error('Error submitting form:', error);
           
          });
      },
      async eliminarSolicitud(item){  
        const result = await Swal.fire({
                    title: '¿Estás seguro?',
                    text: '¡Confirma eliminar la solicitud de inspeccion!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sí, eliminar',
                    cancelButtonText: 'Cancelar'
                });
               
      if (result.isConfirmed) {
        axios.post(this.$rutaServer +'eliminarSolicitudInspeccion',{idcotizacion:item.idcotizacion},
          {
          headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`
          }
        }

        )
          .then(response => {
            console.log(response);
            if(response.status == 200){
              Swal.fire('¡Éxito!', 'Cotizacion eliminada', 'success');
              this.consultarSolicitudes();
            }
           
            
          })
          .catch(error => {
            console.error('Error submitting form:', error);
           
          });
        }
      }
    },
}
</script>
<style>
.circle {
    width: 20px;
    height: 20px;
    background-color: red;
    border-radius: 50%;
    margin-right: 5px;
  }
  
  .circlecolor {
    width: 20px;
    height: 20px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>